import styled from "styled-components";

const FormContainer = styled.div.attrs({
  className: "w-full flex flex-col gap-6 mt-6",
})``;

const TwoThirdWidth = styled.div.attrs({
  className: "sm:w-full md:w-9/12 flex flex-col gap-4",
})``;

const HalfWidth = styled.div.attrs({
  className: "sm:w-full md:w-6/12 flex flex-col gap-4",
})``;

const UploadContainer = styled.button.attrs({
  className:
    "m-auto :text-black",
})``;

const Footer = styled.div.attrs({
  className:
    "w-fit ml-auto my-16 flex gap-12 content-center items-center hover:text-black",
})``;

export default {
  FormContainer,
  TwoThirdWidth,
  HalfWidth,
  UploadContainer,
  Footer,
};